import websid1 from '../assets/Instagram Clone.jpeg';
import websid7 from '../assets/temp_mail.png';
import websid2 from '../assets/courier.jpeg';
import websid3 from '../assets/result_locun.jpeg';
import websid4 from '../assets/finalyer_pr.jpeg';
import websid5 from '../assets/hostel_manag.jpeg';
import websid6 from '../assets/todoapp.png';

import Instagran_vio from '../assets_video/instagram_cloun_video.mp4';
import tempemail_video from '../assets_video/tempemail_video.mp4';
import courier_video from '../assets_video/courier_video.mp4';
import hostel_video from '../assets_video/hostel_video.mp4';
import Todo_video from '../assets_video/Todo_video.mp4';
import Result_video from '../assets_video/React_video.mp4';

import { VscGithub } from "react-icons/vsc";
import { RiLiveLine } from "react-icons/ri";
import { useState } from 'react'; // 1. useState இறக்குமதி செய்யப்பட்டது

function Projects_2() {

    // 1. எந்த ப்ராஜெக்ட்டில் வீடியோ ஓடுகிறது என்பதைக் குறிக்கும் State
    const [playingIndex, setPlayingIndex] = useState(-1); // ஆரம்பத்தில் -1 என்று வைக்கப்பட்டது

    const config = {
        projrcts: [
            {
                image: websid1,
                title: 'Instagram Clone Project',
                description: 'Frontdend:ReactJS + TailwindCSS Backend:Java Spring Boot + MySQL & AWS S3 Bucket',
                link: 'https://ins-spring-boot-applicat-26fce.web.app/',
                gitf: 'https://github.com/sanjaykumarmtt/Instagram-clone-backend.git',
                gitb: 'https://github.com/sanjaykumarmtt/Instagram-clone-backend.git',
                Videourl: Instagran_vio,
                live: true
            },
            {
                image: websid7,
                title: 'TempusMail Project',
                description: 'Frontdend:ReactJS + TailwindCSS Backend:Java Spring Boot + MySQL',
                link: 'https://san-tenp-email-fre.web.app/',
                Videourl: tempemail_video,
                live: true
            },
            {
                image: websid3,
                title: 'Annauniversity result portal clone',
                description: 'Frontdend:React Js Backend:Java Spring Boot,Mysql DB',
                link: 'https://annauniversity-result-cl-565ba.web.app/',
                link2: 'https://annauniversity-result-cl-565ba.web.app/table',
                gitf: 'https://github.com/sanjaykumarmtt/Anna-University-Result-Portal-Clone-Frontend-React-js.git',
                gitb: 'https://github.com/sanjaykumarmtt/Anna-University-Result-Portal-Clone_app_Backend_JavaSpringboot.git',
                Videourl: Result_video,
                live: true,
                con: true
            },
            {
                image: websid2,
                title: 'Sumal Courier pr',
                description: 'Frontdend:React Js Backend:Java Spring Boot,Mysql DB ',
                link: 'https://dinesh-french-uthangarai.web.app/',
                link2: 'https://dinesh-french-uthangarai.web.app/admin',
                Videourl: courier_video,
                live: true,
                con: true
            },
            {
                image: websid4,
                title: 'This is My FinalYear Project LMS',
                description: 'Frontdend:React Js Backend:Java Spring Boot,Mysql DB',
                link: 'https://github.com/sanjaykumarmtt/Finalyear-project-LMS-Frontend.git',
                link2: 'https://github.com/sanjaykumarmtt/LMS-backend-JavaSpring-boot.git',
                gitf: 'https://github.com/sanjaykumarmtt/Finalyear-project-LMS-Frontend.git',
                gitb: 'https://github.com/sanjaykumarmtt/LMS-backend-JavaSpring-boot.git',
                Videourl: "",
                con: true
            }
            , {
                image: websid5,
                title: 'Hostel Management System',
                description: 'Frontdend:React Js Backend:Java Spring Boot,Mysql DB',
                link: 'https://github.com/sanjaykumarmtt/Hostel-Frontend-React-js.git',
                link2: 'https://github.com/sanjaykumarmtt/Hostelbackend-JavaSpring-boot.git',
                gitf: 'https://github.com/sanjaykumarmtt/Hostel-Frontend-React-js.git',
                gitb: 'https://github.com/sanjaykumarmtt/Hostelbackend-JavaSpring-boot.git',
                Videourl: hostel_video,
                con: true
            },
            {
                image: websid6,
                title: 'Todo Application',
                description: 'Frontdend:HTML,CSS,Js Backend:Java Spring Boot,Mysql DB',
                link: 'https://68bf25a3c052f04a6e79763e--cute-cheesecake-3aa27d.netlify.app/spring.html',
                gitf: 'https://github.com/sanjaykumarmtt/Todo_app_frontend.git',
                gitb: 'https://github.com/sanjaykumarmtt/Todo_application_Springboot.git',
                Videourl: Todo_video,
                live: true
            }
        ]
    }

    // 2. வீடியோவை இயக்க State-ஐ மாற்றும் ஃபங்ஷன்
    function handlePlayVideo(id) {
        setPlayingIndex(id);
    }

    // 3. வீடியோ முடிந்தவுடன் மீண்டும் இமேஜைக் காட்டும் ஃபங்ஷன்
    const handleVideoEnd = () => {
        setPlayingIndex(-1); // State-ஐ மீண்டும் -1 ஆக மாற்றுவதால் இமேஜ் ரெண்டர் ஆகும்
    };


    return (
        <div id='project' className="py-20 px-5 justify-center text-white bg-prim">
            <div className="text-4xl font-bold text-center mb-10">
                Projects
            </div>
            <div>
                <p className='font-bold font-hero-font text-xl'>
                    These are some of my best projects. I have built these with React Js, vanilla css & JavaSpring boot, Mysql Check them out.
                </p>
            </div>
            <div className="flex overflow-x-scroll scrollbar-hide cursor-pointer py-10 gap-5 mt-5 px-8 border-white border-2">
                {config.projrcts.map((project, index) => (
                    <div
                        key={index}
                        className="bg-sec rounded-lg shadow-lg overflow-hidden  border-2 border-white placeholder-white bg-transparent p-5 shadow-black hover:shadow-2xl hover:scale-105 duration-300 flex-shrink-0"
                        style={{ width: '300px' }}
                    >
                        <div className="overflow-hidden rounded-s">
                            {playingIndex === index ?
                                <video
                                    src={project.Videourl}
                                    alt={project.title}
                                    controls
                                    autoPlay
                                    muted
                                    loop={false}
                                    onEnded={handleVideoEnd}
                                    className="w-full h-48 object-cover"
                                ></video>
                                :
                                <img src={project.image} alt={project.title} onClick={() => handlePlayVideo(index)} className="w-full h-48 object-cover hover:scale-95 duration-300 active:scale-100" />
                            }
                        </div>
                        <div className="p-4">
                            <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                            <div className='flex justify-between'>
                                {project.live && <div className='flex gap-2 mt-3  font-bold'>
                                    <div className='text-red-500'>
                                        <RiLiveLine />
                                    </div>
                                    <label>It's live</label>
                                </div>}

                                <button className="text-red-600 font-bold hover:underline " onClick={() => handlePlayVideo(index)}>Play Video</button>

                            </div>
                            <p className="text-gray-300 mb-4">{project.description}</p>
                            <div className="flex justify-between items-center">

                                {project.con ?
                                    <div className='flex flex-col gap-1'>
                                        <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Live Demo</a>
                                        <a href={project.link2} target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Admin Project</a>
                                    </div> :
                                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Live Demo</a>
                                }

                                <div className='flex gap-3 justify-self-end mr-4'>
                                    <a href={project.gitf} title='Frontend code in github' className='hover:scale-125 duration-300 '><VscGithub size={21} /></a>
                                    <a href={project.gitb} title='Backend code in github' className='hover:scale-125 duration-300'><VscGithub size={21} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default Projects_2